import { parsePhoneNumber } from 'libphonenumber-js';
import { isArray, isObject, isString } from 'lodash';

export const convertJsonToFormData = (data) => {
  const formData = new FormData();
  for (let field in data) {
    const value = data[field];
    if (isString(value)) {
      formData.append(field, value);
    }
    if (isObject(value)) {
      formData.append(field, value, value.name);
    }
    if (isArray(value)) {
      formData.append(field, JSON.stringify(value));
    }
  }

  return formData;
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return '';

  try {
    const phoneNumber = parsePhoneNumber(phone);
    return phoneNumber.formatInternational();
  } catch {
    return phone;
  }
};
